import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'fromNowPipe',
})
export class TimeFromNowPipe implements PipeTransform {
  transform(date: string): string {
    if (!date) {
      return null;
    }

    return moment(date).fromNow();
  }
}
